export * from '../../components/Quote/Quote';
export { quoteDarkBgVars, quoteWhiteBgVars } from './Quote.palette';
